const trimTrailingSlash = (value) => value?.replace(/\/+$/, '') ?? '';

const parseJson = (value, fallback) => {
    if (!value) {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const siteUrl = trimTrailingSlash(
    process.env.REACT_APP_SITE_URL || 'https://shootconnect.app'
);

const apiBaseUrl = trimTrailingSlash(
    process.env.REACT_APP_API_BASE_URL || `${siteUrl}/api`
);

const defaultScoreDisciplines = [
    { id: 'all', label: 'All Events', path: '/dashboard/score', icon: 'target' },
    { id: 'clay', label: 'Clay Shooting', path: '/dashboard/score/clay', icon: 'clay' },
    { id: 'rifle', label: 'Rifle Shooting', path: '/dashboard/score/rifle', icon: 'rifle' },
    { id: 'game', label: 'Game Shooting', path: '/dashboard/score/game', icon: 'game' }
];

export const appConfig = {
    suiteName: process.env.REACT_APP_SUITE_NAME || 'Connect Sports',
    appName: process.env.REACT_APP_APP_NAME || 'ShootConnect',
    appDisplayName: process.env.REACT_APP_APP_DISPLAY_NAME || 'Shoot Connect',
    sportName: process.env.REACT_APP_SPORT_NAME || 'shooting',
    siteUrl,
    apiBaseUrl,
    supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@shootconnect.app',
    privacyEmail: process.env.REACT_APP_PRIVACY_EMAIL || 'privacy@shootconnect.com',
    venuesEmail: process.env.REACT_APP_VENUES_EMAIL || 'venues@shootconnect.co.uk',
    terminology: {
        communitySingular: process.env.REACT_APP_COMMUNITY_SINGULAR || 'shooter',
        communityPlural: process.env.REACT_APP_COMMUNITY_PLURAL || 'shooters',
        participantSingular: process.env.REACT_APP_PARTICIPANT_SINGULAR || 'shooter',
        participantPlural: process.env.REACT_APP_PARTICIPANT_PLURAL || 'shooters',
        venueSingular: process.env.REACT_APP_VENUE_SINGULAR || 'venue',
        venuePlural: process.env.REACT_APP_VENUE_PLURAL || 'venues',
        equipmentHubTitle: process.env.REACT_APP_EQUIPMENT_HUB_TITLE || 'Gun Cabinet',
        sportPlural: process.env.REACT_APP_SPORT_PLURAL || 'shooting sports'
    },
    navigation: {
        dashboardLabel: process.env.REACT_APP_NAV_DASHBOARD_LABEL || 'Dashboard',
        venuesLabel: process.env.REACT_APP_NAV_VENUES_LABEL || 'Venues',
        scoreLabel: process.env.REACT_APP_NAV_SCORE_LABEL || 'Score Events',
        analyticsLabel: process.env.REACT_APP_NAV_ANALYTICS_LABEL || 'Analytics',
        marketplaceLabel: process.env.REACT_APP_NAV_MARKETPLACE_LABEL || 'Marketplace',
        contentLabel: process.env.REACT_APP_NAV_CONTENT_LABEL || 'News & Blog',
        friendsLabel: process.env.REACT_APP_NAV_FRIENDS_LABEL || 'Friends',
        equipmentLabel: process.env.REACT_APP_NAV_EQUIPMENT_LABEL || 'Equipment',
        downloadLabel: process.env.REACT_APP_NAV_DOWNLOAD_LABEL || 'Score Sheets',
        profileLabel: process.env.REACT_APP_NAV_PROFILE_LABEL || 'Profile',
        subscriptionLabel: process.env.REACT_APP_NAV_SUBSCRIPTION_LABEL || 'Subscription',
        manageVenuesLabel: process.env.REACT_APP_NAV_MANAGE_VENUES_LABEL || 'Manage Venues'
    },
    score: {
        disciplines: parseJson(process.env.REACT_APP_SCORE_DISCIPLINES, defaultScoreDisciplines)
    },
    socialLinks: {
        facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/profile.php?id=61566409050983',
        x: process.env.REACT_APP_SOCIAL_X || 'https://x.com/shootconnect',
        instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/shootconnect.app/'
    },
    messaging: {
        tagline: process.env.REACT_APP_TAGLINE || 'The ultimate platform for clay pigeon, game, and rifle shooting enthusiasts.',
        footerMadeWith: process.env.REACT_APP_FOOTER_MADE_WITH || 'Made with precision for shooting enthusiasts',
        metaDescription: process.env.REACT_APP_META_DESCRIPTION || 'Shoot Connect the ultimate portal for clay shooters.',
        legalIntro: process.env.REACT_APP_LEGAL_INTRO || 'provides a platform for clay pigeon, game, and rifle shooting enthusiasts to connect, track scores, and find clubs.',
        legalDataSummary: process.env.REACT_APP_LEGAL_DATA_SUMMARY || 'We also collect usage data, device information, and shooting scores you choose to record.',
        friendsTagline: process.env.REACT_APP_FRIENDS_TAGLINE || 'Connect with fellow shooters and track your activities together',
        blogTagline: process.env.REACT_APP_BLOG_TAGLINE || 'Latest news, tips, gear reviews, and stories from the shooting community',
        analyticsTagline: process.env.REACT_APP_ANALYTICS_TAGLINE || 'Track your shooting performance and statistics',
        analyticsEmpty: process.env.REACT_APP_ANALYTICS_EMPTY || 'Start logging your shooting events to see analytics',
        mobileAppTagline: process.env.REACT_APP_MOBILE_APP_TAGLINE || 'Shoot Connect works seamlessly across mobile, tablet, and desktop so you can score, browse venues, and manage your account anywhere.'
    }
};
